import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';
import Visualizar from './Visualizar';

const TreinamentosDefault = Default

export default TreinamentosDefault;
export const TreinamentosAdicionar = Adicionar;
export const TreinamentosEditar = Editar;
export const TreinamentosVisualizar = Visualizar;
